import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import { Pane } from '../../layers';
import { Heading } from '../../typography';

var MenuGroup =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(MenuGroup, _React$PureComponent);

  function MenuGroup() {
    _classCallCheck(this, MenuGroup);

    return _possibleConstructorReturn(this, _getPrototypeOf(MenuGroup).apply(this, arguments));
  }

  _createClass(MenuGroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          children = _this$props.children;
      return React.createElement(Pane, {
        paddingY: 8
      }, title && React.createElement(Heading, {
        size: 100,
        marginX: 16,
        marginY: 8
      }, title), children);
    }
  }]);

  return MenuGroup;
}(React.PureComponent);

MenuGroup.displayName = "MenuGroup";

_defineProperty(MenuGroup, "propTypes", {
  /**
   * Title of the menu group.
   */
  title: PropTypes.node,

  /**
   * The children of the menu group.
   */
  children: PropTypes.node
});

export { MenuGroup as default };